/**
 * Retrieves the current window dimensions.
 * @returns { Object } - An object containing the window's inner width and height.
 */
export const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
};